import { Helmet } from 'react-helmet';

interface ITitle {
  title?: string;
}

export const Title = (props: ITitle) => {
  const { title } = props;

  return (
    <Helmet titleTemplate="%s - CAS Shield">
      <title>{title}</title>
    </Helmet>
  );
};
